import {
  TQuarterRange,
  TQuarterDateRangeMap,
  TDonationTypeColorMap,
} from './InKindTab.types';

// ---------------------------------------------------------------------------
// Constants
// ---------------------------------------------------------------------------

export const QUARTER_RANGES: TQuarterRange[] = [
  { quarter: 1, label: 'Q1', startMonth: 1, endMonth: 3 },
  { quarter: 2, label: 'Q2', startMonth: 4, endMonth: 6 },
  { quarter: 3, label: 'Q3', startMonth: 7, endMonth: 9 },
  { quarter: 4, label: 'Q4', startMonth: 10, endMonth: 12 },
];

// TODO: add translation key
export const QUARTER_DATE_RANGES: TQuarterDateRangeMap = {
  1: 'Jan - Mar',
  2: 'Apr - Jun',
  3: 'Jul - Sep',
  4: 'Oct - Dec',
};

export const DONATION_TYPE_COLOR_MAP: TDonationTypeColorMap = {
  MONEY: 'green',
  MATERIALS: 'blue',
  TIME: 'orange',
};

// ---------------------------------------------------------------------------
// Helpers
// ---------------------------------------------------------------------------

/** Format dollar value — NOT cents, already in dollars */
export const formatDollarValue = (value: number): string => {
  return `$${value.toLocaleString('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  })}`;
};
